import {Component, HostListener, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CustomerCareService} from '@api/customer-care.service';
import {animate, animateChild, query, stagger, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-pet-profile',
  templateUrl: './pet-profile.component.html',
  styleUrls: ['./pet-profile.component.scss'],
  animations: [
    trigger('hover', [
      state('in', style({'box-shadow': '0px 10px 8px 4px rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%)'})),
      transition('* => in', [style({'box-shadow': '0px 10px 8px 4px rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%)'}), animate(200)]),
    ]),
    trigger('image-hide', [
      state('in-front', style({ transform: 'translateY(0px)'})),
      state('in-back', style({ transform: 'translateY(40px)'})),
      transition('in-front => in-back', animate('100ms')),
      transition('in-back => in-front', animate('100ms'))
    ]),
    trigger('click', [
      state('front', style({transform: 'rotateY(0deg)', 'z-index': 1})),
      state('back', style({transform: 'rotateY(180deg)', 'z-index': -1})),
      transition('front => back', animate('400ms 0.2ms ease-in-out')),
      transition('back => front', animate('400ms 0.2ms ease-in-out'))
    ])
  ]
})
export class PetProfileComponent implements OnInit, OnChanges {
  @Input()
  pet: {
    petId: string;
    profile?: {
      name: string;
      gender?: number;
      breed?: string[];
      imageProfileUrl?: string;
      petType?: string;
      birthday?: string;
      unit?: 'metric' | 'imperial';
      weight?: number;
    };
    tags?: any[];
    technologies?: any[];
    createdAt?: string;
    createdBy?: string;
    updatedBy?: string;
    updatedAt?: string;
    deleted?: boolean;
  };

  petTags: Array<{
    frequency: string;
    petId: string;
    tagId: string;
    technology: string;
  }>;

  hovered: string;
  clicked = 'front';

  @HostListener('mouseenter', ['$event'])
  @HostListener('mouseleave', ['$event'])
  onHover(event: MouseEvent) {
    const direction = event.type === 'mouseenter' ? 'in' : 'out';
    this.hovered = direction;
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    if ((event.target as Element).classList.contains('flip')) {
      this.clicked = (this.clicked === 'front') ? 'back' : 'front';
    }
  }

  constructor(private ccService: CustomerCareService) { }

  ngOnInit() {
  }

  petWeight(weight: number | undefined, unit: 'metric' | 'imperial' | undefined): string {
    if (!weight || !unit) { return 'Not Specified'; }
    return  weight + (unit === 'metric' ? ' kg' : ' lbs');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.pet) {
      this.ccService.getPetTagsByPetIds([this.pet.petId]).subscribe(
        (value) => {
          this.petTags = value.data;
        }
      , (error) => {
        console.log(error);
      });
    }
  }
}
